import { TranslationsKey } from 'i18nextOptions';
import { ANCESTRY_ROUTE, DASHBOARD_ROUTE, PROFILE_ROUTE } from 'common/constants/urls';

export const DASHBOARD_NAVIGATION_ITEMS: { to: string, label: TranslationsKey, exact?: boolean }[] = [
  { to: DASHBOARD_ROUTE, label: 'dashboard.dashboard', exact: true },
  { to: ANCESTRY_ROUTE, label: 'dashboard.ancestry.ancestry' },
  { to: PROFILE_ROUTE, label: 'dashboard.profile.profile' },
];
